import app from 'flarum/forum/app';
app.initializers.add('val-ui-follow-labels', () => {
  app.translator.addTranslations({
    // Discussions
    'flarum-subscriptions.forum.sub_controls.follow_button': 'Suivre',
    'flarum-subscriptions.forum.sub_controls.following_button': 'Discussion suivie',
    'flarum-subscriptions.forum.sub_controls.ignoring_button': 'Discussion ignorée',
    'flarum-subscriptions.forum.sub_controls.not_following_button': 'Discussion non suivie',
    // Rubriques / étiquettes
    'fof-follow-tags.forum.index.follow_tag_button': 'Suivre cette rubrique',
    'fof-follow-tags.forum.index.unfollow_tag_button': 'Ne plus suivre cette rubrique',
    'fof-follow-tags.forum.sub_controls.follow_button': 'Suivre cette rubrique',
    'fof-follow-tags.forum.sub_controls.following_button': 'Rubrique suivie',
    'fof-follow-tags.forum.sub_controls.lurking_button': 'Rubrique surveillée',
    'fof-follow-tags.forum.sub_controls.ignoring_button': 'Rubrique ignorée',
    'fof-follow-tags.forum.sub_controls.hiding_button': 'Rubrique masquée',
    'fof-follow-tags.forum.sub_controls.not_following_button': 'Rubrique non suivie',
    'fof-follow-tags.forum.sub_controls.header': 'Suivre la rubrique « {tagName} »',
    'fof-follow-tags.forum.sub_controls.subscription_label': 'Choisissez le niveau de suivi pour « {tagName} »',
    'fof-follow-tags.forum.sub_controls.submit_button': 'Confirmer'
  });
});